import axios from 'axios';

import { throwError } from '../../../modules/error';

import type { ArticleType } from './articleType';

export const getPosts = async (companyId: string): Promise<ArticleType[]> => {
  try {
    const url = `https://${
      process.env.REACT_APP_MICRO_CMS_DOMAIN ?? ''
    }.microcms.io/api/v1/article?filters=companyId[equals]${companyId}&richEditorFormat=object`;
    const res = await axios.get<{ contents: ArticleType[] }>(url, {
      headers: {
        'X-MICROCMS-API-KEY': process.env.REACT_APP_MICRO_CMS_API_KEY ?? ''
      }
    });
    return res.data.contents;
  } catch (e) {
    console.log(e);
    throwError(e);
    return [];
  }
};

export const getPost = async (articleId: string): Promise<ArticleType> => {
  try {
    const url = `https://${
      process.env.REACT_APP_MICRO_CMS_DOMAIN ?? ''
    }.microcms.io/api/v1/article/${articleId}?richEditorFormat=object`;
    const res = await axios.get<ArticleType>(url, {
      headers: {
        'X-MICROCMS-API-KEY': process.env.REACT_APP_MICRO_CMS_API_KEY ?? ''
      }
    });
    return res.data;
  } catch (e) {
    throwError(e);
    return {};
  }
};
export const getPostPreview = async (
  articleId: string
): Promise<ArticleType> => {
  try {
    const url = `https://${
      process.env.REACT_APP_MICRO_CMS_DOMAIN ?? ''
    }.microcms.io/api/v1/article/${articleId}?`;
    const res = await axios.get<ArticleType>(url, {
      headers: {
        'X-MICROCMS-API-KEY': process.env.REACT_APP_MICRO_CMS_API_KEY ?? ''
      }
    });
    return res.data;
  } catch (e) {
    throwError(e);
    return {};
  }
};

export const postPosts = async (
  watch: (arg0: string) => any,
  companyId: string,
  filePath: string
): Promise<{ id: string } | undefined> => {
  const url = `https://${
    process.env.REACT_APP_MICRO_CMS_DOMAIN ?? ''
  }.microcms.io/api/v1/article`;
  try {
    const response = await axios.post<{ id: string }>(
      url,
      {
        case: watch('caseStudy') as string,
        companyId,
        content: watch('outline') as string,
        feature: watch('feature') as string,
        imagePath: filePath,
        mediaId: watch('media') as string,
        menu: watch('menu') as string,
        message: watch('message') as string,
        title: watch('title') as string
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-MICROCMS-API-KEY': process.env.REACT_APP_MICRO_CMS_API_KEY
        }
      }
    );
    return response.data;
  } catch (e) {
    throwError(e);
  }
};

export const updatePost = async (
  articleId: string,
  watch: (arg0: string) => any,
  companyId: string,
  filePath: string
): Promise<{ id: string } | undefined> => {
  const url = `https://${
    process.env.REACT_APP_MICRO_CMS_DOMAIN ?? ''
  }.microcms.io/api/v1/article/${articleId}`;
  try {
    const response = await axios.patch<{ id: string }>(
      url,
      {
        case: watch('caseStudy') as string,
        companyId,
        content: watch('outline') as string,
        feature: watch('feature') as string,
        imagePath: filePath,
        mediaId: watch('media') as string,
        menu: watch('menu') as string,
        message: watch('message') as string,
        title: watch('title') as string
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-MICROCMS-API-KEY': process.env.REACT_APP_MICRO_CMS_API_KEY
        }
      }
    );
    return response.data;
  } catch (e) {
    throwError(e);
  }
};
